import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';

@Injectable({
	providedIn: 'root',
})
export class AccountSettingGuard implements CanActivate {

	constructor(
		private router: Router,
		private accountSettingsService: AccountSettingsService
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
		const accountSettingKey = route.data['accountSetting'] as string;

		if (!accountSettingKey) {
			return true;
		}

		// Check if the account setting getter exists and returns true
		const settingValue = this.accountSettingsService[accountSettingKey as keyof AccountSettingsService];

		if (typeof settingValue === 'boolean') {
			return settingValue ? true : this.router.createUrlTree(['/v2']);
		}

		// If the setting is not a boolean, check if it's truthy
		return settingValue ? true : this.router.createUrlTree(['/v2']);
	}
}
